<script setup lang="ts">
import { UiButton, UiEmptyState } from '@acme/ui'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'

// 403 / 404 / generic error pages shared by every app.
const props = defineProps<{ kind: 'forbidden' | 'not-found' | 'error'; reference?: string }>()

const { t } = useI18n()
const router = useRouter()

const content = computed(() => {
  switch (props.kind) {
    case 'forbidden':
      return { icon: 'lock' as const, title: t('shell.status.forbiddenTitle'), text: t('shell.status.forbiddenText') }
    case 'not-found':
      return { icon: 'search' as const, title: t('shell.status.notFoundTitle'), text: t('shell.status.notFoundText') }
    default:
      return { icon: 'alert' as const, title: t('shell.status.errorTitle'), text: t('shell.status.errorText') }
  }
})
</script>

<template>
  <div class="status-page">
    <UiEmptyState :icon="content.icon" :title="content.title" :text="content.text" :tone="kind === 'error' ? 'danger' : 'accent'">
      <p v-if="reference" class="status-page__reference">{{ t('shell.status.reference', { id: reference }) }}</p>
      <UiButton variant="gray" @click="router.push('/')">{{ t('shell.status.backHome') }}</UiButton>
    </UiEmptyState>
  </div>
</template>

<style scoped>
.status-page {
  background: var(--surface-card);
  border: 1px solid var(--separator);
  border-radius: var(--radius-list);
}
.status-page__reference {
  margin: 0;
  font-family: var(--font-mono);
  font-size: var(--type-footnote-size);
  color: var(--text-secondary);
}
</style>
